export const Errors = {
  INITIALIZE_ERROR: 'INITIALIZE_ERROR' as 'INITIALIZE_ERROR',
  ROUTES_ERROR: 'ROUTES_ERROR' as 'ROUTES_ERROR',
};
